var TwoStepsView = (function (CheckoutApiModel) {

    var consent = $('[id$="siteData"]').data('consent');

    var recaptchaReady;

    function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function setGuestEmail(email) {
        window.localStorage && localStorage.setItem('GuestEmail', email);
    }
    function getGuestEmail() {
        return window.localStorage && localStorage.getItem('GuestEmail') || '';
    }

    var TwoStepsModel = CheckoutApiModel.extend({
        defaults: {
            email: null,
            password: null,
            token: null,
            exists: null,
            isValid: null,

            tc: consent.RATermsAndConditionCheckboxTicked || null,
            emailAccept: consent.RAReceiveEmailsCheckboxTicked || null
        },

        _receiveToken: function () {
            if (this._timeout) {
                clearTimeout(this._timeout);
            }

            if (this.get('isValid') === true && this.get('email') !== '') {
                var _this = this;
                this._timeout = setTimeout(function () {

                    setGuestEmail(_this.get('email'));

                    api.getTokenByEmail({ email: _this.get('email') }).done(function (result) {
                        var data = result.Value;
                        _this.set('exists', data ? data.Exists : null);
                        _this.set('token', data ? data.Token : null);
                    });
                }, 1000);
            }
        },

        signin: function () {
            var $def = new $.Deferred();

            if (!recaptchaReady) {
                recaptchaReady = recaptcha.init('recaptcha');
            }

            var _this = this;
            var invitedBy = window.cookie && cookie.get('invitedBy') || null;

            recaptchaReady.done(function () {
                recaptcha.execute().done(function (token) {
                    api.signInByToken({
                        token: _this.get('token'),
                        password: _this.get('password'),
                        parameters: {
                            tcAccepted: _this.get('tc'),
                            emailsAccepted: _this.get('emailAccept')
                        },
                        invitedBy: invitedBy || globalQueryParams.get("invitedBy") || null,
                        referredBy: globalQueryParams.get("referredBy") || null,
                        voucherID: globalQueryParams.get("voucherID") || kos.guidEmpty,
                        captchaResponse: token
                    }, { wait: true }).done($def.resolve);
                });
            });
            return $def.promise();
        },

        forgotPassword: function () {
            var $def = new $.Deferred();
            api.forgotPassword({
                email: this.get('email')
            }, { wait: true }).done($def.resolve);
            return $def.promise();
        },

        setEmail: function (email) {
            if (email === this.get('email')) return;
            var isValid = validateEmail(email);
            this.set('isValid', isValid);
            this.set('email', email);
            this.set('token', null);
            this._receiveToken();
        },
        setPassword: function (pass) {
            if (pass === this.get('password')) return;
            this.set('password', pass);
        },
        isValid: function () {
            return this.get('isValid');
        },
        setEmailAccept: function (value) {
            return this.set({ emailAccept: value });
        },
        setTC: function (value) {
            return this.set({ tc: value });
        },
        getEmail: function () {
            return this.get('email');
        },
        getValidatedEmail: function () {

            var email = this.get('email');
            var isValid = validateEmail(email);
            this.set('isValid', isValid);

            return isValid;
        },
        getEmailAccept: function () {
            return this.get('emailAccept');
        },
        getTC: function () {
            return this.get('tc');
        }
    });

    var _model = null;

    var _getModel = function() {
        if (_model === null) {
            _model = new TwoStepsModel();
            app.customerEmailModel = _model;
        }
        return _model;
    }

    return Backbone.View.extend({

        events: {
            'keyup #CustomerEmail': '_changed',
            'change #CustomerEmail': '_changed',
            'blur #CustomerEmail': '_changed',

            'keyup #CustomerPassword': '_changedPass',
            'change #CustomerPassword': '_changedPass',
            'blur #CustomerPassword': '_changedPass',

            'click @btnLogin': '_signin',
            'click @forgotPasswordBtn': '_forgotPassword',
            'click @displayLoginForm': '_displayLoginForm'

            //'focus #CustomerEmail': '_focus',
            //'mouseup #CustomerEmail': '_clearedByCross'
        },

        initialize: function (opts) {
            _.bindAll(this);

            this.model = _getModel();

            var settings = CheckoutSettings.getBasketSettings();
            var isFacebookLoginEnabled = settings && settings.FacebookLoginEnabled || false;

            window.isFacebookLoginEnabled = isFacebookLoginEnabled;

            if (this.model._isAuthorized() || !app.settings.get('UseGuestCheckout')) {
                this.$el.remove();
            } else {

                this.signinForm = opts.signinForm;
                this.signInButton = opts.signInButton;
                this.switchers = opts.switchers;
                this.agreementText = opts.agreementText;

                this.model.on('change:email', this._updateEmail);
                this.model.on('change:emailAccept', this._updateEmailAccept);
                this.model.on('change:tc', this._updateTc);
                this.model.on('change:password', this._updatePassword);
                this.model.on('change:isValid', this._isValid);
                this.model.on('change:token', this._toggle);

                if (!opts.onlyButtons) {
                    var tmpl = $.tmpl('guest_two_steps_auth', {
                        isFacebookLoginEnabled: isFacebookLoginEnabled
                    });
                    this.$el.html(tmpl);
                }

                this.$el.addClass('customerEmail-wrapper');

                if (!opts.onlyEmail) {
                    this.switchTC = new Switch({
                        defaultValue: consent.RATermsAndConditionCheckboxTicked || null,
                        trueText: kos.getPageTemplate('js_Yes'),
                        falseText: kos.getPageTemplate('js_No'),
                        label: kos.getPageTemplate('_consentWithTCText'),
                        testClass: 'test-guest-tac-switch',
                        onChanged: this._switchChanged
                    });

                    this.switchEmailPromo = new Switch({
                        defaultValue: consent.RAReceiveEmailsCheckboxTicked || null,
                        trueText: kos.getPageTemplate('js_Yes'),
                        falseText: kos.getPageTemplate('js_No'),
                        label: kos.getPageTemplate('_consentWithEmailsText'),
                        testClass: 'test-guest-emails-switch',
                        onChanged: this._switchChangedEmail
                    });

                    if (!this.signinForm && opts.switchers) {
                        this.switchTC.appendTo(this.$el);
                        this.switchEmailPromo.appendTo(this.$el);
                    }

                }

                if (this.signinForm) {
                    this._initFacebookAuth();
                } else {
                    this.$('@facebookAuthForm').remove();
                }

                this.$emailField = this.$('#CustomerEmail');
                this.$passwordField = this.$('#CustomerPassword');

                var currentEmail = getGuestEmail();
                if (currentEmail) {
                    this.$emailField.val(currentEmail);
                    this.model.setEmail(currentEmail);
                }

                if (opts.onlyTC) {
                    this.$('@CustomerEmailForm').addClass('hidden-block');
                }

                if (!opts.signInButton) {
                    this.$('@signInButton').remove();
                }

                if (!opts.agreementText) {
                    this.$('@agreementText').remove();
                }

                //if (!opts.onlyTC) {
                //    this.model.on('change:email', this._update);
                //}
                //if (!opts.onlyEmail) {
                //    this.model.on('change:tc', this._update);
                //    this.model.on('change:emailAccept', this._update);
                //}
            }
        },

        _initFacebookAuth: function() {
            this.facebook = new FacebookAuthorization({
                appId: GlobalSettings.Fid,
                authCallback: _.bind(this._fbAuthCallback, this),
                btnID: "@btnFacebookAuth"
            });  
        },

        _fbAuthCallback: function (data) {
            var invitedBy = window.cookie && cookie.get('invitedBy') || null;
            data = _.extend({}, data || {}, {
                invitedBy: invitedBy || globalQueryParams.get("invitedBy") || null,
                referredBy: globalQueryParams.get("referredBy") || null,
                voucherID: globalQueryParams.get("voucherID") || kos.guidEmpty,
                password: null
            });
            api.loginFacebook(data, { wait: true }).done(function () {
                window.location.reload();
            });
        },

        _updateEmail: function(m) {
            //this.$emailField.val(m.get('email'));
        },

        _updatePassword: function(m) {
            this.$passwordField.val(m.get('password'));
        },

        _updateEmailAccept: function(m) {
            this.switchEmailPromo && this.switchEmailPromo.setValue(m.get('emailAccept'));
        },

        _displayLoginForm: function (e) {
            window.app && app.event && app.event.logIn();
            window.landingFormShow({ mode: 'Login' }).done(function () {
                document.location.href = '/Checkout.aspx';
            });
            eventEmitter.trigger('changeLeftButton',
                {
                    func: function () {
                        document.location.href = '/Checkout.aspx';
                    }
                });
      },

        _updateTc: function (m) {
            this.switchTC && this.switchTC.setValue(m.get('tc'));
        },

        _switchChanged: function (val) {
            if (this.switchTC) {
                if (window.__promoTC__ !== val) {
                    window.__promoTC__ = val;
                }
                val !== null && this.model.setTC(val);
            }
        },

        _switchChangedEmail: function (val) {
            if (this.switchEmailPromo) {

                if (window.__promoVal__ !== val) {
                    window.__promoVal__ = val;
                }
                val !== null && this.model.setEmailAccept(val);
            }
        },

        _changed: function (e) {
            var email = e.target.value;
            this.model.setEmail(email);
        },

        _changedPass: function (e) {
            var pass = e.target.value;
            this.model.setPassword(pass);
        },

        _toggle: function (m) {
            this._displaySigninForm(!!m.get('token'));
        },

        _isValid: function (m) {
            this.$emailField.toggleClass('emailErrorField', !m.isValid());
        },

        _displaySigninForm: function (display) {

            if (!this.model.get('exists')) {
                display = false;
            }

            if (this.signinForm) {
                this.$('#CustomerPassword').attr('type', 'password');

                this.$('@forgotPasswordBtn').toggleClass('hidden-block', !this.model.get('exists'));
                this.$('@btnLogin').text(this.model.get('exists') ? kos.getPageTemplate('mobile_Login') : kos.getPageTemplate('_Signup'));


                this.$('@signinForm').toggleClass('hidden-block', !display);
                this.$('@signInButton').toggleClass('hidden-block', display);
                this.$('@guestText').toggleClass('hidden-block', !(!display && this.model.get('isValid')));
            }
        },

        _signin: function() {
            this.model.signin().done(function() {
                window.location.reload();
            });
        },

        _forgotPassword: function () {
            var $el = this.$('@forgotPasswordBtn');
            var timeout = setTimeout(function () {
                $el.text('sending...');
            }, 500);

            this.model.forgotPassword().done(function () {
                clearTimeout(timeout);
                $el.text('Password sent to your email address');
            }).always(function () {
                setTimeout(function () {
                    $el.text(kos.getPageTemplate('_ForgotUsernamePassword'));
                }, 5000);
            });
        },

    });

})(CheckoutApiModel);